// Footer component for footer section
const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div className="footer">
      Created By
      <a
        href="https://www.linkedin.com/in/alokjha2504/"
        target="_blank"
        title="Alok Jha's Linkedin Profile"
      >
        Alok Jha
      </a>
      <i className="fa-solid fa-copyright"></i>
      {year}
    
        <strong>
           Food<span>Fire</span>
        </strong>
      
    </div>
  );
};

export default Footer;
